import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { conseguirNinos, ConseguirPrograma } from '../../api/Groups';
import queryString from 'query-string';
import { useHistory, useLocation } from 'react-router-dom';
import Loading from '../../components/Loading';
import { useBreadcrumb } from '../../context/BreadcrumbContext';

const GroupPage = () => {
    const { t } = useTranslation();
    const [child, setChild] = useState([]);
    const [prog, setProg] = useState('');
    const [loading, setLoading] = useState(true);
    const [groupName, setGroupName] = useState('');
    const [error, setError] = useState<string | null>(null);
    const navigate = useHistory();
    const location = useLocation();

    useBreadcrumb(groupName ? [{ label: groupName }] : []);

    useEffect(() => {
        (async () => {
            try {
                setLoading(true)
                setError(null)
                const queryParams = queryString.parse(window.location.search, { decode: true });

                if (typeof queryParams.id === "string" && typeof queryParams.name === "string") {
                    const children = await conseguirNinos(queryParams.id);
                    setGroupName(queryParams.name);

                    if (!children || children.length === 0) {
                        setChild([]);
                        return;
                    }

                    setChild(children);

                    const firstInstanceId = children[0]?.instance_id;
                    if (!firstInstanceId) {
                        setError(t('group_page.error_no_instance_id'));
                        return;
                    }

                    const progData = await ConseguirPrograma(queryParams.id, firstInstanceId);
                    if (!progData?.program_name) {
                        setError(t('group_page.error_no_program'));
                        return;
                    }
                    setProg(progData.program_name);
                }
            } catch (err: any) {
                const httpStatus = err?.response?.status;
                const msg = !httpStatus
                    ? t('group_page.error_connection')
                    : t('group_page.error_status', { status: httpStatus });
                console.error('[GroupPage] error loading group:', err);
                setError(msg);
            } finally {
                setLoading(false);
            }
        })();
    }, [location.search, t]);

    if (loading) return <Loading />;

    return (
        <div className="bg-white w-100" style={{ height: '75vh', display: 'flex', flexDirection: 'column' }}>
            {/* Header */}
            <div
                className="bg-white border-bottom px-4 pt-3"
                style={{ flex: '0 0 auto', zIndex: 1000 }}
            >
                <h4 className="m-0 text-primary pb-3">{groupName}</h4>
            </div>

            {/* Scrollable Table */}
            <div
                className="px-4 pt-3"
                style={{
                    flex: '1 1 auto',
                    overflowY: 'auto',
                }}
            >
                {error && (
                    <div className="alert alert-danger">{error}</div>
                )}
                {child.length > 0 && (
                    <div className="table-responsive">
                        <table className="table align-middle">
                            <thead className="table-light">
                                <tr>
                                    <th>{t('group_page.column_name')}</th>
                                    <th>{t('group_page.column_age')}</th>
                                    <th>{t('group_page.column_birthday')}</th>
                                    <th>{t('group_page.column_diagnosis')}</th>
                                    <th>{t('group_page.column_report')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {child.map((patient: any, index) => (
                                    <tr key={index}>
                                        <td>{patient.name}</td>
                                        <td>{patient.month}</td>
                                        <td>{patient.birthday}</td>
                                        <td>
                                            <span
                                                className="text-primary"
                                                style={{ cursor: 'pointer' }}
                                                onClick={() =>
                                                    navigate.push(`/hitos?user_id=${patient.user_id}&instance_id=${patient.instance_id}&instance_name=${patient.name}&instance_months=${patient.number_month}&language=es&program_name=${prog}`)
                                                }
                                            >
                                                {t('group_page.view_link')}
                                            </span>
                                        </td>
                                        <td>
                                            <span
                                                className="text-primary"
                                                style={{ cursor: 'pointer' }}
                                                onClick={() =>
                                                    navigate.push(`/reporte-progreso?user_id=${patient.user_id}&instance_id=${patient.instance_id}&instance_name=${patient.name}&instance_months=${patient.number_month}&language=es&program_name=${prog}`)
                                                }
                                            >
                                                {t('group_page.view_link')}
                                            </span>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        </div>
    );
};

export default GroupPage;
